<template>
    <div class="content-card mb-4">
        <div class="content-card-title">ยอดแทงทั้งหมด</div>
        <div class="content-card-body">
            <div class="d-flex justify-content-between">
                <h2 class="mb-0">฿{{ getTotalBet }}</h2>
                <button type="button" class="btn btn-outline-secondary btn-sm btn-icon" data-bs-toggle="tooltip"
                    data-bs-placement="top" title="Tooltip on top"><i
                        class="fa-icon fa-regular fa-circle-info mx-2"></i></button>
            </div>
            <p class="text-medium mb-0">ยอดแทงของสมาชิกภายใต้ทั้งหมด (฿{{ getTotalBet }})</p>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    getTotalBet: {
      type: String,
      default: '0.00'
    }
  },
  data () {
    return {
    }
  },
  methods: {
    numberWithCommas (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  computed: {
  }
}
</script>
